<template>
  <v-sheet v-if="hasContent" class="account-list" :data-cy="`account-${parts.join('-')}`">
    <div v-if="shows('who')" class="d-flex align-start">
      <v-icon class="mr-3">mdi-account-circle</v-icon>
      <!-- min-width lets a long list of roles wrap instead of pushing out of the menu -->
      <div class="account-who">
        <div class="text-body-2">
          {{ user.email }}<span v-if="fedBrowserId" class="text--secondary"> ({{ fedBrowserId }})</span>
        </div>
        <div class="text-caption text--secondary">
          {{ user.roleName }}<span v-if="user.streams"> · streams {{ user.streams }}</span>
        </div>
      </div>
    </div>

    <div
      v-if="shows('menuSwitch') || showsApiSwitch || shows('logout')"
      class="d-flex flex-wrap align-center"
      :class="{'mt-2': shows('who')}"
    >
      <v-switch
        v-if="shows('menuSwitch')"
        :input-value="useNewMenu"
        label="new menu"
        title="pages grouped in columns, with search, stars and your own sections"
        dense
        hide-details
        class="mt-0 pt-0 mr-6"
        data-cy="nav-use-new-menu"
        @change="$emit('use-new-menu', !!$event)"
      />
      <v-btn-toggle
        v-if="showsApiSwitch"
        :value="apiTarget"
        mandatory
        dense
        :title="baseURL"
        data-cy="api-switch"
        @change="$emit('choose-api', $event)"
      >
        <v-btn
          v-for="(target, name) in apiTargets"
          :key="name"
          :value="name"
          small
          :data-cy="`api-${name}`"
        >{{ target.label }}</v-btn>
      </v-btn-toggle>
      <v-spacer v-if="shows('logout')"/>
      <v-btn
        v-if="shows('logout')"
        small
        outlined
        class="ml-4"
        data-cy="logout"
        @click="$emit('logout')"
      >logout</v-btn>
    </div>
  </v-sheet>
</template>

<script>
import api from '@/api';

/** who is logged in, the api being used, logout and the choice of menu */
export default {
  name: 'AccountList',
  props: {
    user: {type: Object, required: true},
    fedBrowserId: {type: String, default: null},
    /** 'local', 'staging' or 'production'; null when VUE_APP_API_URL is none of them */
    apiTarget: {type: String, default: null},
    useNewMenu: {type: Boolean, required: true},
    /**
     * the parts to show, so the new menu can place each: 'who', 'menuSwitch', 'apiSwitch'
     * (on a development build only) and 'logout'
     */
    parts: {type: Array, default: () => ['who', 'menuSwitch', 'apiSwitch', 'logout']},
  },
  methods: {
    shows(part) {
      return this.parts.includes(part);
    },
  },
  computed: {
    showsApiSwitch() {
      return this.shows('apiSwitch') && !this.isProductionBuild;
    },
    /** the api switch alone shows nothing on a production build */
    hasContent() {
      return this.parts.some(part => part !== 'apiSwitch') || this.showsApiSwitch;
    },
    isProductionBuild() {
      return api.isProductionBuild;
    },
    apiTargets() {
      return api.apiTargets;
    },
    baseURL() {
      return api.defaults.baseURL;
    },
  },
};
</script>

<style scoped>
.account-who {
  flex: 1 1 0;
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
